<template>
  <div class="welfare">
    <div class="welwidth">
      <div class="title">
        <h2>
          <span class="tit-l">
            <img src="@/assets/images/new-img/driver/tit-l.png" width="34" />
          </span>美菜司机福利
          <span class="tit-r">
            <img src="@/assets/images/new-img/driver/tit-r.png" width="35" />
          </span>
        </h2>
      </div>

      <ul class="welfare-list">
        <li class="welfare-item">
          <img src="@/assets/images/new-img/driver/welfare-1.png" />
          <!-- <span>专业的业务培训</span> -->
        </li>
        <li class="welfare-item">
          <img src="@/assets/images/new-img/driver/welfare-2.png" />
          <!-- <span>不定期的员工关怀</span> -->
        </li>
        <li class="welfare-item">
          <img src="@/assets/images/new-img/driver/welfare-3.png" />
          <!-- <span>
            清晰的晋升通道：
            <br />司机-站长-主管经理岗
          </span> -->
        </li>
        <li class="welfare-item big">
          <img src="@/assets/images/new-img/driver/welfare-4.png" />
          <!-- <span>
            成为运营司机，
            <br />维护商户，收入倍增
          </span> -->
        </li>
        <li class="welfare-item big">
          <img src="@/assets/images/new-img/driver/welfare-5.png" />
          <!-- <span>
            活泼开朗的同事，
            <br />一帮有情有义的兄弟
          </span> -->
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: "conditions",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.welfare {
  background: #f8f8f8;
  padding: 75px 0;
  .welwidth {
    width: 1016px;
    margin: 0 auto;
  }
}
.title {
  height: 90px;
  h2 {
    font-size: 34px;
    position: relative;
    width: 300px;
    margin: 0 auto;
    text-align: center;
    .tit-l {
      position: absolute;
      left: 0;
      top: 15px;
    }
    .tit-r {
      position: absolute;
      right: 0;
      top: 2px;
    }
  }
}
.welfare-list {
  display: flex;
  flex-wrap: wrap;
  .welfare-item{
    position: relative;
    margin: 8px;
    font-size: 24px;
    &.big {
      &>img {
        width: 492px;
        height: 329px;
      }
    }
    &>img {
      width: 322px;
      height: 214px;
    }
  }
  span {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    text-align: center;
    line-height: 1.6;
    color:#fff; 
    padding-top: 102px;
  }
}
</style>
